import { GET_BALANCE, UPDATE_ALIAS_CONSOLIDATE } from './../constants';
import { handleActions } from "redux-actions"
//import { arrayhierarchy } from '../functions/arrays';

export const balances  = handleActions(
  {
    [ GET_BALANCE ]: (state, action) => {
      let dataReturn = {}
      if (action.payload.name ==='Timeout') {
        dataReturn = state
      } else
      if (action.payload.error ) {
        dataReturn = state
      } else {
        //let arrResult = arrayhierarchy(action.payload.data, ['AHORRO', 'CORRESPONSALIA', 'AHORRO MENORES DE EDAD', 'CERTIFICADOS DE APORTACION', 'AHORRO PROGRAMADO'], 'Tipo')
        // console.log(arrResult)
        dataReturn = action.payload.data
      }
      return dataReturn
    },
    [UPDATE_ALIAS_CONSOLIDATE]: (state, action) => {
      
      //console.log(state)
      //console.log(action)
      let indexAccount = state.findIndex((item) => item.numeroCuenta === action.payload.numeroCuenta)

      //console.log("index ", indexAccount)
      let newArrayAccount = state
      newArrayAccount[indexAccount].alias = action.payload.alias
      return newArrayAccount
    },
  }, []
)